import React from 'react';
import SelectField from './../Form/SelectField';

const FormP17T4 = React.memo((props) => {
    return (
        <form action="">
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> Cardiothoracic &amp; Vascular Surgery Folder.</div>
                <div className="description">
                    A customized two-pocket folder that has card slits on both pockets. Printed on quality, glossy cover paper.
                    Perfect for discharge paperwork, patient education, or marketing materials.
                </div>
                <div className="description-list">
                    <span className="label">Paper Specs/Detail:</span>
                    <ul>
                        <li>9".75 h x 12" w folded with extended reinforced vertical tab</li>
                        <li>4 color + High Gloss AQ</li>
                        <li>12pt. C1S (120# Gloss Cover Stock Cover (heavy thickness)</li>
                        <li>Double business card slits (left &amp; right) pockets</li>
                        <li>Two 4" pockets w/bc slits</li>
                        <li>Available in color only</li>
                        <li>Last updated on 11-1-2021</li>
                    </ul>
                </div>
            </div>
            <h5>Pricing</h5>
            <div className="pricing-container">
                <table className="table table-sm table-hover table-striped">
                    <thead>
                        <tr>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Each</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>250</td>
                            <td>$295.00</td>
                            <td>$1.18</td>
                        </tr>
                        <tr>
                            <td>500</td>
                            <td>$590.00</td>
                            <td>$1.18</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form>
    );
});

export default FormP17T4;
